// extracted by mini-css-extract-plugin
module.exports = {"chips":"styles__chips___2Z3Bg","active":"styles__active___2TL4Q"};